import styled from 'styled-components';

export const ModalWrapper = styled.div`
  width: 100%;
  box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  @media (max-width: 650px) {
    width: 90%;
    min-height: 598px;
    padding: 0px 5px;
    margin: auto;
  }

  @media (max-width: 400px) {
    margin: 16px auto;
  }
`;
export const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px auto;
  max-width: 600px;
`;
export const ModalImgDiv = styled.img`
  height: 200px;
`;

export const ModalTextWrapper = styled.div`
  text-align: center;
  margin: 10px 5px;
  max-width: 574px;
  justify-self: center;
  @media (min-width: 850px) and (max-width: 950px) {
    margin: 10px 20px;
  }
  @media screen and (max-width: 700px) {
    margin: 10px 20px;
  }
`;
